import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import img1 from '../../assets/img/books/1.png';
import img2 from '../../assets/img/books/2.png';
import img3 from '../../assets/img/books/3.png';
import img4 from '../../assets/img/books/4.png';
// import img5 from '../../assets/img/clients/05.png';

const clientslide = [
	{
		img: img1
		// , link: 'https://www.amazon.com/gp/product/B08DC1ZDHH?pf_rd_r=6MG226JG42AA5M37WY4B&pf_rd_p=6fc81c8c-2a38-41c6-a68a-f78c79e7253f' 
	},
	{ img: img2 },
	{ img: img3 },
	{ img: img4 },
	// { img: img5 },
	{ img: img1 },
	{ img: img2 },
	{ img: img3 },
	{ img: img4 },
	// { img: img5 },
]

const settings = {
	infinite: true,
	slidesToShow: 5,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 5000,
	speed: 500,
	arrows: false,
	fade: false,
	dots: false,
	swipe: true,
	responsive: [
		{
			breakpoint: 991,
			settings: {
				slidesToShow: 4,
			},
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 400,
			settings: {
				slidesToShow: 1,
			},
		},
	],
}
class Client extends Component {
	render() {
		return (<div>

			<div className="row justify-content-center">
				<div className="col-lg-8">
					<div className="cta-content text-center">
						<div className="section-title both-border mb-30">
							<span className="title-tag">Explore J.W's publications</span>
							{/* <h2 className="title">Looking to improve your business, dental practice or ministry? We have the best guide for you.</h2>	 */}
							<h3>In this series of books, J.W guides business owners on how to get started with outsourcing from recruiting, training, and integrating a virtual team member into everyday business.</h3>
							<p>

								Drawing from his personal experience of managing several businesses over a span of 30+ years.
								He highlights the many benefits and troubleshoots possible problems with outsourcing.
								Business owners will realize that they can employ some of the best minds and talented
								professionals on the globe at a fraction of the current cost structure.

							</p>
						</div>
						<a href="https://globalteambook.com/" target="_blank" rel="noopener noreferrer" className="main-btn main-btn-3">Buy Books</a>
					</div>
				</div>
			</div>

			<br />
			<br />

			<Slider className="row align-items-center justify-content-between" id="clientSlider" {...settings}>
				{clientslide.map((item, i) => (
					<div key={i} className="col client-img d-block text-center">
						<a href="https://globalteambook.com/" target="_blank" rel="noopener noreferrer">
							{/* <Link to="/" className="client-img d-block text-center"> */}
							<img src={item.img}
								// link={item.link} 
								alt="" />
							{/* </Link> */}
						</a>
					</div>
				))}
			</Slider>
		</div>

		);
	}
}

export default Client;